/** 
 * 陈智文  js桥
 * 做了ios和android统一规范
 */

window.jsBridge = {
    call (methods, params, cb) {
        let cbName = ''
        if (cb && typeof cb === 'function') {
            !window.cbCount && (window.cbCount = 0)
            window.cbCount ++
            cbName = 'nfCallBack' + window.cbCount
            window[cbName] = cb
        }
        if (cb && typeof cb === 'string') {
            cbName = cb
        }
        if (window.T.os.ios) {
            try {
                params = JSON.parse(params)
            } catch (e) {
                window.console.warn('当前参数是对象')
            }
            let postObj = {
                data: params,
                function: methods
            }
            if (cb) {
                postObj.callBack = cbName
            }
            window.console.log(postObj)
            window.console.log(methods)
            window.webkit.messageHandlers.NFNativeFunction.postMessage(postObj)
        } else {
            let options = {
                function: methods,
                data: params,
                callback: cbName
            }
            options = JSON.stringify(options)
            window.console.log(options)
            window.activity.NFNativeFunction(options)
        }
    }
}
